const React = require("react");
const T = React.PropTypes;

const FileType = require("../types/FileType.js");
const MetadataSpec = require("../types/MetadataSpec.js");

const HollowButton = require("./HollowButton.jsx");

const styles = {
    DisplayName: {
        display: "inline-block",
        marginLeft: 20,
        color: "#eee",
        textDecoration: "underline",
        fontWeight: "bold"
    },
    ChangeButton: {
        marginLeft: 15,
        fontSize: 13,
        letterSpacing: 1
    }
}

const ReviewForm = React.createClass({
    propTypes: {
        FileType: FileType.Type,
        FileCount: T.number,
        OnSubmit: T.func,
        Lock: T.bool,
        HasInvalids: T.bool,
        MetadataIsOkay: T.bool
    },
    render() {
        const style = Object.assign({}, this.props.style || {}, {
            display: "flex",
            alignItems: "center",
            padding: "10px 0",
            borderTop: "1px solid #ddd",
            color: "#fff",
            backgroundColor: "#1a282a"
        });

        const disableSubmit =
            (this.props.FileCount || 0) === 0
            || this.props.Lock
            || this.props.HasInvalids
            || !this.props.MetadataIsOkay;

        const submitTitle =
            this.props.HasInvalids ? "Please remove all invalid files before submitting." : null;

        return (<div style={style}>
            <div style={{ flex: "3", paddingLeft: 20 }}>
                <h3 style={{ margin: 0, marginBottom: 15 } }>
                    Selected file type:
                    <span style={styles.DisplayName}>
                        {this.props.FileType.DisplayName}
                    </span>
                    <HollowButton style={styles.ChangeButton}
                                  onClick={this.props.OnCancel}
                                  disabled={this.props.Lock}>
                        Change
                    </HollowButton>
                </h3>
                <h4 style={{ margin: 0, marginBottom: 15 } }>
                    {this.props.FileCount || 0} files selected
                </h4>
            </div>
            <div style={{ flex: "1", textAlign: "right", paddingRight: 20 }}>
                <button className="btn btn-primary"
                style={{ height: 60, fontSize: 20 }}
                disabled={disableSubmit}
                onClick={this.props.OnSubmit}
                title={submitTitle}>
                Submit
                </button>
            </div>
        </div>);
    }
});

module.exports = ReviewForm;


// WEBPACK FOOTER //
// ./src/components/ReviewForm.jsx